import React from "react";

import ContactUs from "./ContactUs";
import "./Django.css";
import pythonWebPDF from "../assets/Python Web Development - Codex Future Syllabus.pdf";



const Django = () => {
  return (
    <>

      <section className="django-section">
        <div className="django-container">
          <h1 className="django-title">Introduction to Python Django Course</h1>
          <h2 className="django-subtitle">Backend Website Development</h2>
          <p className="django-rating">(4.8 Reviews)</p>
          <p className="django-duration">Duration: 3 Months | 10+ Guaranteed Interviews</p>

          <p className="django-description">
            Get complete Python Django training in Indore with 3 Industry Level projects and placement assistance.
            Our Django Training in Indore is curated by industry experts in accordance with the industry practices and trends.
            This Django Training Course will take you through advance concepts in Python Object-oriented programming,
            Django Architecture, Django Projects, Django Models, Django Admins, Django urls and views, Django templates and static files,
            Django caching, Django signals and other much needed skills to Django framework.
          </p>

          <button
  className="django-btn"
  onClick={() => window.open(pythonWebPDF, "_blank")}
>
  📘 Download Syllabus
</button>


          <h3 className="django-heading">
            What is Django framework? and What is it used for?
          </h3>

          <p className="django-text">
            Django is a Python-based full stack web development framework that allows developers to build interactive
            websites using Python. It supports rapid development and advocates pragmatic and clean code.
          </p>

          <p className="django-text">
            We start training our students from, “What is Django?” and “How to Learn Python Django?”. From day 1, our trainers
            will help you with many assignments and assessments for better practice. We customize our Django Course to suit
            each and every student in a unique way. Our Python Django Training Program includes all the major topics such as
            Django program structure, execution steps, memory management, and garbage collections, data types, statements and syntax,
            file operations, functions, modules and packages, classes, exception handling and lot more.
          </p>

          <p className="django-text">
            We can straight away hit Django if you are good at Python programming. To make you proficient, we also give Python tutorial for beginners.
          </p>

          <h3 className="django-heading">Are you searching for the best Django Training in Indore?</h3>

          <ul className="django-list">
            <li>✅ Do you want to Learn Django to become “A Django Expert”?</li>
            <li>✅ Are you a beginner who wants to attend Django tutorials?</li>
            <li>✅ Are you an IT professional eager to dive deep into Python Django?</li>
          </ul>

          <p className="django-text">
            Whatever it may be... If any of these above questions are hitting your mind, we are here to help you in the best
            possible way based on your availability and requirements. All our trainers are currently working as Senior Python
            Developers and Django Experts with more than 6 years of industry experience.
          </p>

          <h3 className="django-heading">We Offer:</h3>

          <ul className="django-list">
            <li><strong>Classroom Django Classes</strong> — For students who prefer weekday or weekend sessions.</li>
            <li><strong>Online Django Classes</strong> — For those who want to attend online or backup lessons.</li>
            <li><strong>Django Online Courses</strong> — For overseas students or online-only learners.</li>
            <li><strong>Django Tutorials</strong> — For slow learners and complete beginners.</li>
          </ul>
        </div>
      </section>

      <ContactUs />
      
    </>
  );
};

export default Django;
